<template>
  <i :class="'bee-icon-' + name"></i>
</template>

<script>

export default {
  name: 'BeeIcon',
  props: {
    name: String
  },
  data() {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icon/icon.vue